import { NoteProperty } from "./NoteProperty";

export type HubSpotNote = {
    id: number;
    properties: NoteProperty | null;
}

export const defaultNote: HubSpotNote = {id: 0, properties: null}; 